import { AtendimentoProfissional } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { OrientacaoFormModel, OrientacaoRowModel } from '../types/OrientacoesModel'
import { sortOrientacoes } from './sortOrientacoes'

export function mergeSortOrientacoes(
  orientacoesDatabase: OrientacaoRowModel[],
  orientacoesCache: OrientacaoFormModel[],
  atendimentoProfissional: AtendimentoProfissional,
  sort: string[]
): OrientacaoRowModel[] {
  let novasOrientacoesCache = orientacoesCache.map((value, index) =>
    createOrientacaoFromCache(value, index, atendimentoProfissional)
  )
  novasOrientacoesCache = sortOrientacoes(novasOrientacoesCache, sort)
  const orientacoesDatabaseOrdenadas = sortOrientacoes(orientacoesDatabase, sort)
  return [...novasOrientacoesCache, ...orientacoesDatabaseOrdenadas]
}

function createOrientacaoFromCache(
  orientacaoCache: OrientacaoFormModel,
  index: number,
  atendimentoProfissional: AtendimentoProfissional
): OrientacaoRowModel {
  return {
    cacheId: index,
    descricao: orientacaoCache.descricao,
    atendimentoProfissional: atendimentoProfissional,
  }
}
